// extracted by mini-css-extract-plugin
export default {"media":"Project_media__KQ5jI"};